import UsersCheckBoxList from './UsersCheckBoxList'

export default UsersCheckBoxList
